/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";
// Styles
import styles from "./ManualAssignmentTable.css";

const ManualAssignmentTable = ({
  active,
  cellClick,
  cellMove,
  checkAvailabality,
  checkSelected,
  dateOccupiedSlots,
  finishSelection,
  locationDetails,
  openingHoursList,
  setActiveTrue,
  tableRef
}) => {
  const handleCellMove = ({ hour, index, stationId }) => {
    if (
      !(
        dateOccupiedSlots &&
        dateOccupiedSlots.bookings.length &&
        checkAvailabality({
          hour,
          index,
          stationId
        })
      ) &&
      active
    ) {
      cellMove({
        stationId,
        hour,
        index
      });
    } else {
      finishSelection();
    }
  };

  const handleCellClick = ({ hour, index, stationId }) => {
    if (
      !(
        dateOccupiedSlots &&
        dateOccupiedSlots.bookings.length &&
        checkAvailabality({
          hour,
          index,
          stationId
        })
      )
    ) {
      setActiveTrue();
      cellClick({
        hour,
        index,
        stationId
      });
    }
  };

  return (
    <div style={styles.tableContainer}>
      <table
        className="table table-bordered dataTable no-footer table-no-margin"
        style={styles.table}
        width="100%"
      >
        <thead>
          <tr role="row">
            <th colSpan="4" />
            {openingHoursList.map((hour, index) => (
              <th key={index} colSpan="4">
                {hour}
              </th>
            ))}
          </tr>
        </thead>
        <tbody ref={tableRef}>
          {locationDetails.stations.map((station, index) => {
            const stationId = station.id;

            return (
              <tr key={index} role="row">
                <td colSpan="4" style={station.disabled ? styles.disabledStation : null}>
                  {station.name}
                </td>
                {openingHoursList.map((hour) =>
                  [...Array(4)].map((cell, index) => (
                    <td
                      key={index}
                      onMouseDown={() =>
                        handleCellClick({
                          hour,
                          index,
                          stationId
                        })
                      }
                      onMouseMove={() =>
                        handleCellMove({
                          hour,
                          index,
                          stationId
                        })
                      }
                      onMouseUp={finishSelection}
                      onTouchCancel={finishSelection}
                      onTouchEnd={finishSelection}
                      onTouchStart={() =>
                        handleCellClick({
                          hour,
                          index,
                          stationId
                        })
                      }
                      style={
                        dateOccupiedSlots &&
                        dateOccupiedSlots.bookings.length &&
                        checkAvailabality({
                          hour,
                          index,
                          stationId
                        })
                          ? styles.disabledCell
                          : checkSelected({
                              hour,
                              index,
                              stationId
                            })
                          ? {
                              backgroundColor: `#3b9ff3`,
                              borderColor: `#3292E2`
                            }
                          : null
                      }
                    />
                  ))
                )}
              </tr>
            );
          })}
          <tr />
        </tbody>
      </table>
    </div>
  );
};

ManualAssignmentTable.propTypes = {
  active: PropTypes.bool,
  cellClick: PropTypes.func.isRequired,
  cellMove: PropTypes.func.isRequired,
  checkAvailabality: PropTypes.func.isRequired,
  checkSelected: PropTypes.func.isRequired,
  dateOccupiedSlots: PropTypes.object,
  finishSelection: PropTypes.func.isRequired,
  locationDetails: PropTypes.object,
  openingHoursList: PropTypes.array,
  setActiveTrue: PropTypes.func.isRequired,
  tableRef: PropTypes.object
};

export default ManualAssignmentTable;
